import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import { forwardRef, useStyleConfig, omitThemingProps, useFormControlContext, chakra } from '@chakra-ui/react';
import { filterUndefined, cx } from '@chakra-ui/utils';
import useBackwardsCompatibility from '../../utils/useBackwardsCompatibility.js';
var _excluded = ["className", "align", "decoration", "casing"];
// Backwards compatibility map for `variant`
// This maps old variants to new props.
var BACKWARDS_COMPATIBILITY_MAP = {
  variant: {
    success: {
      colorScheme: 'green'
    },
    danger: {
      colorScheme: 'red'
    },
    info: {
      colorScheme: 'blue'
    },
    warning: {
      colorScheme: 'yellow'
    }
  }
};
/**
 * Feedback
 *
 * React component used to render feedback text. Renders a `span` by default.
 */

var Feedback = forwardRef(function (originalProps, ref) {
  var variant = originalProps.variant;
  var props = useBackwardsCompatibility(BACKWARDS_COMPATIBILITY_MAP, originalProps, {
    variant: "The <Feedback /> variant prop \"".concat(variant, "\" is deprecated. Please use the appropriate \"colorScheme\" props.")
  });
  var styles = useStyleConfig('Feedback', props);
  var _omitThemingProps = omitThemingProps(props);
  _omitThemingProps.className;
  _omitThemingProps.align;
  _omitThemingProps.decoration;
  _omitThemingProps.casing;
  var rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var field = useFormControlContext();
  var aliasedProps = filterUndefined({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  if (field && !(field !== null && field !== void 0 && field.isInvalid)) return null;
  return /*#__PURE__*/React__default.createElement(chakra.span, _extends({
    ref: ref
  }, field === null || field === void 0 ? void 0 : field.getErrorMessageProps(rest, ref), {
    className: cx('chakra-feedback', props.className)
  }, aliasedProps, rest, {
    __css: styles
  }));
});
export { Feedback };